import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { CategoryBody, CategoryDetails, CategoryListItem } from "types/api/category";

import { AdvancedListRequest } from "types/api/commons";

function useCategoryApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllCategory = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<CategoryListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<CategoryListItem>>({
            url: "/category",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneCategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<CategoryDetails> => {
        return get<PathParamsWithId, undefined, CategoryDetails>({
            url: "/category/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createCategory = React.useCallback((body: CategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, CategoryBody, ResponseWithId>({
            url: "/category",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateCategory = React.useCallback((pathParams: PathParamsWithId, body: CategoryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, CategoryBody, null>({
            url: "/category/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteCategory = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/category/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllCategory,
        getOneCategory,
        createCategory,
        updateCategory,
        deleteCategory
    };
}

export default useCategoryApi;